import { render, staticRenderFns } from "./mtbe2024Dashboard.vue?vue&type=template&id=67f1c1c3&"
import script from "./mtbe2024Dashboard.vue?vue&type=script&lang=js&"
export * from "./mtbe2024Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports